// extracted by mini-css-extract-plugin
module.exports = {"baseButton":"BaseButton_baseButton__12NcY"};